import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import InvoiceListing from 'src/supportPortal/views/payoutReports/InvoiceListing'

export default function ClinicBrandPayoutInvoiceReceipts({ clinicBrandSlug }) {
  //   const { brandSlug } = useParams()
  const [clinicBrand, setClinicBrand] = useState()
  async function getClinicBrand() {
    const resp = await getSPDataWithParams(`/api/secure/cc/support/clinic-brand/get`, {
      slug: clinicBrandSlug,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const brand = getDataMapFromCommonResponse(resp)?.['clinic-brand']
        setClinicBrand(brand)
      }
    }
  }

  useEffect(() => {
    getClinicBrand()
  }, [])

  return (
    <>
      <SupportHeader
        heading={`${
          clinicBrand?.brandName || clinicBrand?.title || clinicBrand?.brandShortName
        } Payout Invoices`}
        // subHeading="View and download clinic payout reports"
      />
      {clinicBrand ? (
        <InvoiceListing
          targetEntityType="clinic-brand"
          bookedEventsListingApiSignature="/api/secure/cc/support/invoices/payout-invoice/booked-events"
          hideTargetEntityIdFilter
          entityListOverride={[clinicBrand]}
          initialFilters={{
            targetEntityTypes: 'clinic-brand ',
            targetEntityIds: clinicBrand?.id,
          }}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
          <CircularProgress />
        </div>
      )}
    </>
  )
}
